import NamedDto from 'modules/base/dto/NamedDto';

export class LummusModelInputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.title = null;
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.code = null;
		/** @type {string} */
		this.unit_op_code = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.min_value = null;
		/** @type {string} */
		this.max_value = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _LummusModelInputAttributeEditDtoProps
	 * @property {string} title
	 * @property {string} type
	 * @property {string} value
	 * @property {string} code
	 * @property {string} unit_op_code
	 * @property {string} uom
	 * @property {string} min_value
	 * @property {string} max_value
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _LummusModelInputAttributeEditDtoProps} LummusModelInputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {LummusModelInputAttributeEditDtoProps} props
	 * @returns {LummusModelInputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.title = props.title;
		this.type = props.type;
		this.value = props.value;
		this.code = props.code;
		this.unit_op_code = props.unit_op_code;
		this.uom = props.uom;
		this.min_value = props.min_value;
		this.max_value = props.max_value;
		this.orderIndex = props.orderIndex;
		return this;
	}
}

export default LummusModelInputAttributeEditDto;
